import ActiveUsersIcon from "../../Components/Common/svg/activeUsers";
import InActive from "../../Components/Common/svg/inactive";
import UsersIcon from "../../Components/Common/svg/usersIcon";
import StatusBadge from "../../Components/UI/statusBadge";
import TableActions from "../../Components/UI/table/TableActions";

export const userConfigStats = (statsUsers) => [
  {
    title: "مجموع العملاء",
    count: statsUsers?.total_users,
    color: "#0F2B42",
    bgIcon: "#E7EAEC",
    icon: <UsersIcon />,
  },
  {
    title: "العملاء النشطة",
    count: statsUsers?.active_users,
    color: "#00835B",
    bgIcon: "#E6F3EF",
    icon: <ActiveUsersIcon />,
  },
  {
    title: "العملاء غير النشطة",
    count: statsUsers?.inactive_users,
    color: "#EB5757",
    bgIcon: "#FDECEC",
    icon: <InActive />,
  },
  {
    title: "العملاء المحظور",
    count: statsUsers?.blocked_users,
    color: "#EB5757",
    bgIcon: "#FDECEC",
    icon: <InActive />,
  },
];

export const userColumns = [
  {
    label: "معرف العميل",
    render: (row) => <div className="text-green">#{row.id}</div>,
  },

  { label: "اسم العميل", accessor: "name" },

  { label: "رقم الهاتف", accessor: "phone" },
  { label: "عدد الطلبات", accessor: "order_count" },

{
  label: "الحالة",
  render: (row) => (
    <StatusBadge
      status={row.status}
      statusLabel={row.status_label}
    />
  ),
},
  {
    label: "الإجراءات",
    render: (row) => (
      <TableActions
        show={`${process.env.PUBLIC_URL}/user/${row.id}`}
        viewPermission={"view_user"}
      />
    ),
  },
];
